import React from 'react'
import { connect } from 'react-redux'
import Navbar from 'components/navbar/Navbar'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import scrollIntoView from 'scroll-into-view'

const Hero = props => (
  <div className='hero--container'>
  	<Navbar homePage={true}/>
		<div className='d-flex align-items-center hero--content-container' id='landing-page-hero'>
			<div className='container-fluid px-md-5 px-3'>
				<div className='row'>
					<div className='col-lg-6 d-sm-flex align-items-center justify-content-center'>
						<div className='hero--col--text-container'>
							<h1 className='mt-md-0 mt-5 mb-2 hero--col--h1'>OWLGO</h1>
							<h2 className='mb-4 hero--col--h2'>Let's Go!</h2>
							<h3 className='mb-4 hero--col--h3'>Invite guests and manage their responses on the go. Track your event live and capture powerful data about your event's performance, right at your fingertips.</h3>
							<div className='d-sm-flex flex-row justify-content-start'>
								<Link to='/enquiry' className='mb-3 mr-3'>
									<button className='btn btn-secondary d-flex align-items-center'>
										<span className='pr-5'>Schedule a Demo</span>
										<img alt='' src='img/button-arrow.svg' style={{width: '10.4px', height: '12px'}} />
									</button>
								</Link>
								{/*<HashLink exact to='/#features' className='mb-3' scroll={el =>  scrollIntoView(el,{ time:700, align:{top:0, left: 0}})}>
									<button className='btn btn-secondary d-flex align-items-center'>
										<span className='pr-5'>Learn More</span>
										<img alt='' src='img/button-arrow.svg' style={{width: '10.4px', height: '12px'}} />
									</button>
								</HashLink>*/}
							</div>
						</div>
					</div>
					<div className='col-lg-6 text-center'>
						<img className='hero--col--image' alt='header' src='img/owlgo-1.png' />
					</div>

				</div>
			</div>
		</div>
  </div>
)

const mapStateToProps = ( state, props ) => ({

})

const mapDispatchToProps ={

    }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Hero)



// WEBPACK FOOTER //
// ./src/components/hero/Hero.js